//* Libraries imports
import React from "react";
import { Container } from "@mui/material";

//* Components Imports
import ScrollTransition from "components/ScrollTransition";

//* Styles Imports
import styles from "./styles.module.css";

function ErpSection() {
  return (
    <section
      id="erp-section"
      data-testid="erp-section"
      aria-label="Seção informativa sobre integração inteligente de estoque e preços"
      className={styles.erpSection}
    >
      <Container
        id="erp-container"
        data-testid="erp-container"
        aria-label="Container da seção de integração"
        maxWidth="xl"
      >
        <div
          id="erp-grid"
          data-testid="erp-grid"
          aria-label="Layout dividido de integração inteligente"
          className={styles.erpGrid}
        >
          <div
            id="erp-text-container"
            data-testid="erp-text-container"
            aria-label="Textos explicativos de integração"
            className={styles.erpTextContainer}
          >
            <ScrollTransition
              id="erp-title-transition"
              data-testid="erp-title-transition"
              aria-label="Animação do título"
            >
              <h2
                id="erp-title"
                data-testid="erp-title"
                aria-label="Título: Integração Automatizada"
                className={styles.sectionTitle}
                style={{ textAlign: "left" }}
              >
                Integração <span className={styles.highlight}>Automatizada</span>
              </h2>
              <div
                id="erp-divider"
                data-testid="erp-divider"
                aria-label="Linha decorativa"
                className={styles.divider}
                style={{ margin: "1rem 0" }}
              />
            </ScrollTransition>
 
            <ScrollTransition
              id="erp-details-transition"
              data-testid="erp-details-transition"
              aria-label="Animação da descrição"
              delay={200}
            >
              <p
                id="erp-details-1"
                data-testid="erp-details-1"
                aria-label="Descrição do custo zero para integração"
                className={styles.erpDetails}
              >
                <span className={styles.highlight}>Custo Zero</span> para cadastrar e conectar sua loja ao iGooB.
              </p>
              <p
                id="erp-details-2"
                data-testid="erp-details-2"
                aria-label="Descrição da sincronização simultânea"
                className={styles.erpDetails}
              >
                Estoque, preços e quantidades são atualizados <span className={styles.highlight}>simultaneamente</span> no aplicativo.
              </p>
              <p
                id="erp-details-3"
                data-testid="erp-details-3"
                aria-label="Descrição da visibilidade sem trabalho manual"
                className={styles.erpDetails}
              >
                Sua loja visível para milhares de clientes sem trabalho manual.
              </p>
            </ScrollTransition>
          </div>

          <div
            id="erp-graphic-wrapper"
            data-testid="erp-graphic-wrapper"
            aria-label="Visualização do fluxo de dados"
            className={styles.syncGraphicContainer}
          >
            <ScrollTransition
              id="erp-graphic-transition"
              data-testid="erp-graphic-transition"
              aria-label="Animação do fluxo de dados"
              delay={300}
            >
              <div
                id="sync-graphic-container"
                data-testid="sync-graphic-container"
                aria-label="Diagrama animado de conexões"
                className={styles.syncGraphicContainer}
              >
                <svg
                  id="sync-svg"
                  data-testid="sync-svg"
                  aria-label="Linhas de conexões em SVG"
                  className={styles.syncSvg}
                  viewBox="0 0 400 400"
                >
                  <line
                    id="line-asaas"
                    data-testid="line-asaas"
                    aria-label="Linha Asaas"
                    x1="80"
                    y1="80"
                    x2="200"
                    y2="200"
                    className={styles.syncLine}
                  />
                  <line
                    id="line-app-cliente"
                    data-testid="line-app-cliente"
                    aria-label="Linha App Cliente"
                    x1="320"
                    y1="80"
                    x2="200"
                    y2="200"
                    className={styles.syncLine}
                  />
                  <line
                    id="line-app-entregador"
                    data-testid="line-app-entregador"
                    aria-label="Linha App Entregador"
                    x1="80"
                    y1="320"
                    x2="200"
                    y2="200"
                    className={styles.syncLine}
                  />
                  <line
                    id="line-painel"
                    data-testid="line-painel"
                    aria-label="Linha Painel Administrativo"
                    x1="320"
                    y1="320"
                    x2="200"
                    y2="200"
                    className={styles.syncLine}
                  />
                </svg>

              <div
                  id="hub-node"
                  data-testid="hub-node"
                  aria-label="Ponto Central iGooB Hub"
                  className={styles.hubNode}
                >
                  iGooB Hub
                </div>
                <div
                  id="hub-ripple"
                  data-testid="hub-ripple"
                  aria-label="Efeito de ondas de transmissão"
                  className={styles.hubRipple}
                >
                </div>

                <div
                  id="node-asaas"
                  data-testid="node-asaas"
                  aria-label="Nó da plataforma Asaas"
                  className={`${styles.platformNode} ${styles.asaasNode}`}
                >
                  Asaas
                </div>
                <div
                  id="node-app-cliente"
                  data-testid="node-app-cliente"
                  aria-label="Nó Cliente"
                  className={`${styles.platformNode} ${styles.appClienteNode}`}
                >
                  Cliente
                </div>
                <div
                  id="node-app-entregador"
                  data-testid="node-app-entregador"
                  aria-label="Nó Entregador"
                  className={`${styles.platformNode} ${styles.appEntregadorNode}`}
                >
                  Entregador
                </div>
                <div
                  id="node-painel"
                  data-testid="node-painel"
                  aria-label="Nó Administrativo"
                  className={`${styles.platformNode} ${styles.painelNode}`}
                >
                  Administrativo
                </div>
              </div>

              <p
                id="sync-caption"
                data-testid="sync-caption"
                aria-label="Legenda: Data Syncs Instantly Across Platforms"
                className={styles.syncCaption}
              >
                Data Syncs Instantly Across Platforms
              </p>
            </ScrollTransition>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default ErpSection;
